import { render } from "./cellphoneComponent.vue?vue&type=template&id=33adbf53"
import script from "./cellphoneComponent.vue?vue&type=script&lang=js"
export * from "./cellphoneComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__